var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('div',[_vm._v(" seat ")]),_c('lotterySeat',{attrs:{"fightRoom":_vm.fightRoom,"fightResult":_vm.fightResult,"seat":_vm.seat,"singlePlayTime":_vm.singlePlayTime}},[_vm._v("seatT")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }